import { LaboratorioAnalise } from "@/contexts/laboratorio/laboratorioAnalise/model/LaboratorioAnalise";
import { api } from "@/shared/api/api";

export const createLaboratorioAnaliseApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<LaboratorioAnalise[]>(
      "/laboratorios-analise/todos",
      { headers }
    );
    return data;
  };

  return { listAll };
};
